module.exports = __webpack_public_path__ + "static/img/IMG_20241208_161513.f6e82b96.jpg";